<script setup>
import {useBaseStore} from "~/stores/base";

/** props **/
const props = defineProps({
  product: {
    default: {},
    required: true
  }
})

const current = ref(0)

/** computed **/
const isMobile = computed(() => useBaseStore().getterIsMobile)

const handleTab = (index) => {
  current.value = index
}
</script>

<template>
  <div class="module-product-description-mobile" v-if="isMobile">
    <div class="tabs">
      <div class="tab" :class="{active: current === 0}" @click="handleTab(0)">Description</div>
      <div class="tab" :class="{active: current === 1}" @click="handleTab(1)">About the Brand</div>
    </div>
    <div
      class="content"
      v-html="current === 0 ? product.description : current === 1 ? product.brandBriefIntroductionAndStory : ''"
    />
  </div>
  <div class="module-product-description-desktop" v-else>
    <div class="tabs">
      <div class="tab" :class="{active: current === 0}" @click="handleTab(0)">Description</div>
      <div class="tab" :class="{active: current === 1}" @click="handleTab(1)">About the Brand</div>
    </div>
    <div
      class="content"
      v-html="current === 0 ? product.description : current === 1 ? product.brandBriefIntroductionAndStory : ''"
    />
  </div>
</template>

<style scoped lang="scss">
@import "src/assets/config";

.module-product-description-mobile {
  margin-top: 24px;
  padding: 0 16px;

  .tabs {
    display: flex;

    .tab {
      font-family: "TWK Lausanne";
      font-size: 14px;
      font-style: normal;
      font-weight: 650;
      line-height: 20px; /* 142.857% */
      color: $color-gray-600;

      width: 100%;
      padding: 12px 16px;

      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: 0.5px solid $color-gray-300;

      cursor: pointer;
    }

    .active {
      color: $color-gray-800;
      border-bottom: 1.5px solid $color-gray-800
    }
  }

  .content {
    padding-top: 15px;

    /* Text xs/Regular */
    font-family: "TWK Lausanne";
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: 18px; /* 150% */
  }
}

.module-product-description-desktop {
  margin-top: 32px;

  .tabs {
    display: flex;

    .tab {
      font-family: "TWK Lausanne";
      font-size: 14px;
      font-style: normal;
      font-weight: 650;
      line-height: 20px; /* 142.857% */
      color: $color-gray-600;

      width: 123.5px;
      height: 28px;

      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: 0.5px solid $color-gray-300;

      cursor: pointer;
    }

    .active {
      color: $color-gray-800;
      border-bottom: 1.5px solid $color-gray-800
    }
  }

  .content {
    padding-top: 15px;

    /* Text xs/Regular */
    font-family: "TWK Lausanne";
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: 18px; /* 150% */
  }
}
</style>
